import { Box } from '@mui/material';
import styled from 'styled-components';
import { themeOptions } from 'styles';

export const StyleNoticeTab = styled(Box)`
  .noticeTabListWrap {
    .MuiTabs-root {
      min-height: auto;
    }
    //버튼 커스텀
    button {
      height: 42px;
      min-width: auto;
      min-height: auto;
      padding: 9px 14px;
      color: #a4a7a7;
      line-height: 1.5;
      font-size: 16px;
      font-weight: 600;
      &.Mui-selected {
        color: ${themeOptions.palette.green.main};
      }
    }
    //버튼 하단 바 indicator 커스텀
    .MuiTabs-indicator {
      background-color: ${themeOptions.palette.green.main};
    }
  }

  .MuiTabPanel-root {
    padding: 16px 0;
  }
`;

export const StyledNoticeDateRange = styled.div`
  display: flex;
  align-items: center;
  p {
    margin-right: 8px;
    font-size: 14px;
    color: ${themeOptions.palette.fontColor.main};
    & + .MuiStack-root {
      height: 48px;
      //padding-top:0;
      .MuiFormControl-root label {
        color: ${themeOptions.palette.gray.dark};
        //transform:translate(12px, 4px) scale(0.75);
        &.Mui-focused {
          color: ${themeOptions.palette.gray.dark};
        }
      }
      .MuiOutlinedInput-notchedOutline {
        display: block;
        &.Mui-focused {
          //border-color:red;
        }
      }
      fieldset {
        border-color: #dadada !important;
      }
    }
  }
`;
